export default "__VITE_PUBLIC_ASSET__98ba93de__"